import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "verify-content" }
const _hoisted_2 = {
  key: 0,
  class: "rotate-tip-bar"
}
const _hoisted_3 = { class: "image-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "rotate-circle-box"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "slider-track-wrap"
}
const _hoisted_10 = { class: "track-tip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshRight = _resolveComponent("RefreshRight")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_DArrowRight = _resolveComponent("DArrowRight")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "安全验证",
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.visible) = $event)),
    width: "360px",
    "destroy-on-close": true,
    "close-on-click-modal": false,
    "before-close": _ctx.handleClose,
    "custom-class": "behavior-captcha-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.captchaType === 'rotate' && _ctx.originalImageBase64)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[9] || (_cache[9] = _createElementVNode("span", null, "请拖动滑块使图片与背景对齐", -1)),
              _createVNode(_component_el_icon, {
                class: "refresh-btn point",
                onClick: _ctx.handleRefresh
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_RefreshRight)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.captchaType === 'blockPuzzle' && _ctx.originalImageBase64)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("img", {
                  src: _ctx.originalImageBase64,
                  class: "bg-img",
                  alt: "captcha",
                  onDragstart: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                }, null, 40, _hoisted_4),
                (_ctx.jigsawImageBase64)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.jigsawImageBase64,
                      class: "jigsaw-img",
                      style: _normalizeStyle({ left: _ctx.moveX + 'px' }),
                      alt: "jigsaw",
                      onDragstart: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 44, _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "corner-refresh-btn point",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)), ["stop"]))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_RefreshRight)
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.captchaType === 'rotate' && _ctx.originalImageBase64)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("img", {
                  src: _ctx.originalImageBase64,
                  class: "bg-img",
                  alt: "rotate-bg",
                  onDragstart: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                }, null, 40, _hoisted_6),
                (_ctx.jigsawImageBase64)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("img", {
                        src: _ctx.jigsawImageBase64,
                        class: "rotate-img",
                        style: _normalizeStyle({ transform: `rotate(${Math.round((_ctx.moveX / (310 - 47)) * 360)}deg)` }),
                        alt: "rotate-piece",
                        onDragstart: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
                      }, null, 44, _hoisted_8)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "corner-refresh-btn point",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleRefresh && _ctx.handleRefresh(...args)), ["stop"]))
                }, [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_RefreshRight)
                    ]),
                    _: 1
                  })
                ])
              ], 64))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        (_ctx.originalImageBase64)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["track-highlight", { error: _ctx.tipStatus === 'error' }]),
                style: _normalizeStyle({ width: _ctx.moveX + 40 + 'px' })
              }, null, 6),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.isDragging
              ? ''
              : _ctx.captchaType === 'blockPuzzle'
              ? '向右拖动滑块完成拼图'
              : '向右拖动滑块使图片与背景对齐'), 1),
              _createElementVNode("div", {
                class: _normalizeClass(["track-handle", { error: _ctx.tipStatus === 'error', dragging: _ctx.isDragging }]),
                style: _normalizeStyle({ left: _ctx.moveX + 'px' }),
                onMousedown: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onHandleMouseDown && _ctx.onHandleMouseDown(...args))),
                onTouchstart: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onHandleTouchStart && _ctx.onHandleTouchStart(...args)))
              }, [
                _createVNode(_component_el_icon, { class: "handle-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DArrowRight)
                  ]),
                  _: 1
                })
              ], 38)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["status-msg", {
          success: _ctx.tipStatus === 'success',
          error: _ctx.tipStatus === 'error'
        }])
        }, _toDisplayString(_ctx.tipMsg), 3)
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}